import { useEffect, useState } from 'react';
import { getPage, listServicesApi, listIndustriesApi } from './api';
import { services as fallbackServices, industries as fallbackIndustries } from '../data/mock';

// ---- Pages ----------------------------------------------------------------
const _pageCache = {};

export function usePage(slug, fallback = {}) {
  const [content, setContent] = useState(_pageCache[slug]?.content || fallback);
  const [loaded, setLoaded] = useState(!!_pageCache[slug]);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const doc = await getPage(slug);
        if (alive && doc && doc.content) {
          _pageCache[slug] = doc;
          setContent(doc.content);
        }
      } catch {}
      finally {
        if (alive) setLoaded(true);
      }
    })();
    return () => { alive = false; };
  }, [slug]);

  return { content, loaded };
}

// ---- Services -------------------------------------------------------------
let _servicesCache = null;

export function useServices() {
  const [items, setItems] = useState(_servicesCache || fallbackServices);
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const data = await listServicesApi();
        if (alive && Array.isArray(data) && data.length) {
          _servicesCache = data;
          setItems(data);
        }
      } catch {}
    })();
    return () => { alive = false; };
  }, []);
  return items;
}

export function useServiceBySlug(slug) {
  const items = useServices();
  return items.find((s) => s.slug === slug);
}

// ---- Industries -----------------------------------------------------------
let _industriesCache = null;

export function useIndustries() {
  const [items, setItems] = useState(_industriesCache || fallbackIndustries);
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const data = await listIndustriesApi();
        if (alive && Array.isArray(data) && data.length) {
          _industriesCache = data;
          setItems(data);
        }
      } catch {}
    })();
    return () => { alive = false; };
  }, []);
  return items;
}
